import React, { useEffect, useState } from 'react';
import {
  WixPatternsDashboardBaseProvider,
  CairoProviderProps,
} from './CairoDashboardBaseProvider';
import { createClient } from '@wix/sdk';
import { testkit } from '@wix/bex-utils/@wix/bex-bundled-mini-essentials/testkit';
import { whenRequest } from '@wix/bex-utils/@wix/bex-bundled-mini-essentials/http-client/testkit/client';
import {
  exportServiceMocks,
  appSettingsMocks,
} from '@wix/bex-core/testkit/client';
import { dataExtensionServiceMocks } from '../test-utils/dataExtensionServiceMocks';

export function WixPatternsDashboardTestProvider(props: CairoProviderProps) {
  const [dashboard] = useState(() => ({
    showToast: () => {
      return {
        remove: () => {},
      };
    },
    navigate: () => {},
  }));

  const [environment] = useState(() => ({
    locale: 'en',
    pageLocation: {
      pageId: '',
      pathname: '',
      search: '',
      hash: '',
    },
  }));

  const [client] = useState(() => createClient({}));

  const [essentials] = useState(() =>
    testkit.getTestContext({
      experiments: {
        bag: {},
      },
      httpClient: {
        scenarios: [
          ...appSettingsMocks(whenRequest),
          ...exportServiceMocks(whenRequest).mocks,
          ...dataExtensionServiceMocks(whenRequest).mocks,
        ],
      },
    }),
  );

  useEffect(() => {
    const state = {
      mounted: true,
      afterAll: null as (() => void) | null,
    };
    testkit.beforeAll().then(({ afterAll }) => {
      state.afterAll = afterAll;
      if (!state.mounted) {
        afterAll();
      }
    });

    return () => {
      state.mounted = false;
      state.afterAll?.();
    };
  }, []);

  return (
    <WixPatternsDashboardBaseProvider
      {...props}
      dashboard={dashboard}
      environment={environment}
      client={client}
      essentials={essentials}
    />
  );
}
